import { createCustomerPortalSession } from "@/api/privateApi";
import { cn } from "@/lib/utils";
import { userSubscriptionSelector } from "@/redux/user/userSlice";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { BannerStructure } from "../RootBanner";

export const GettingReadyFc26Banner = ({
  onClickLeft,
  onClickRight,
}: {
  onClickLeft: () => void;
  onClickRight: () => void;
}) => {
  const navigate = useNavigate();
  const subscription = useSelector(userSubscriptionSelector);
  const handleOnClickCTA = () => {
    if (subscription === "gold") {
      createCustomerPortalSession();
    } else {
      navigate("/subscription");
    }
  };

  return (
    <BannerStructure
      bgUrl="bg-[url('https://cdn.easysbc.io/fc25/banners/fc26gettingready/fc25gettingreadybg2.png')]"
      title="The secret to a great start in FC 26. Grind less and build better squads."
      onClickCTA={handleOnClickCTA}
      onClickLeft={onClickLeft}
      onClickRight={onClickRight}
    >
      <div
        className="h-full w-full absolute bottom-0 touch-device:hidden"
        style={{
          background:
            "linear-gradient(0deg, #1A1E23 20.65%, rgba(26, 30, 35, 0.00) 100%)",
        }}
      />

      <div
        className="absolute w-full h-full hidden touch-device:block"
        style={{
          background:
            subscription === "diamond"
              ? "linear-gradient(90deg, rgba(26, 30, 35, 0.65) 20.65%, rgba(26, 30, 35, 0.00) 100%)"
              : "linear-gradient(90deg, rgba(26, 30, 35, 0.85) 50.65%, rgba(26, 30, 35, 0.00) 100%)",
        }}
      />
      <img
        className={cn(
          "absolute h-36 touch-device:h-[137px] top-12 touch-device:top-36 touch-device:right-32",
          subscription === "diamond"
            ? "touch-device:top-16"
            : "touch-device:top-36",
        )}
        src={`${import.meta.env.VITE_APP_ASSETS_BASE_URL}/fc25/banners/fc26gettingready/fc26readytext.png`}
        alt="myclubbanner"
      />
    </BannerStructure>
  );
};
